import { useRef } from "react";
import useGetImages from "../useGetImages";
import empty from '../../assets/images/empty.jpg';
const ProductModal = ({ setCartModal, id, productDetail }) => {
  const { image: uri } = useGetImages(
    "product_pictures",
    id,
    `${productDetail?.URUN_KOD}_B`
  );
  console.log("productDetail", productDetail);
  console.log("uri", uri);
  const modalRef = useRef();

  const handleModalClose = (e) => {
    if (!modalRef.current.contains(e.target)) setCartModal(false);
  };

  return (
    <div
      onClick={handleModalClose}
      className="z-10 bg-gray-900/70 fixed top-0 left-0 w-full h-full flex justify-center items-center"
    >
      <div
        ref={modalRef}
        className="w-[90%] flex flex-col md:flex-row justify-between items-center max-w-[600px] m-auto p-8 bg-white rounded-md min-h-[240px]"
      >
        {/* {uri && (
          <img
            src={uri}
            alt="product image"
            className="object-cover w-80 rounded-lg"
          />
        )} */}
        {uri ? (
          <img
            src={uri}
            alt="product image"
            className="object-cover w-80 rounded-lg"
          />
        ):(
          <img
          src={empty}
          alt="product image"
          className="object-cover w-80 rounded-lg shadow-md"
        />

        )
      }

        <div className="w-full md:ml-5 flex items-center md:items-start flex-col">
          <h2 className="text-lg font-semibold text-zinc-800 mt-3">
            {productDetail?.URUN_ADI}
          </h2>
          <p className="text-zinc-600 my-2 text-center">
            <span>{productDetail?.URUN_ACIKLAMA}</span>
          </p>

          <button
            onClick={() => setCartModal(false)}
            className="w-full mt-3 bg-[#fecc4c] basis-2/12 text-center text-white p-2 flex justify-center gap-2 items-center md:px-8 rounded-md text-sm md:text-base"
          >
            <span className="md:block">Kapat</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;
